module.exports = __webpack_public_path__ + "img/translationeditor_19.9104b4ac.jpg";